import React from "react";
import CustomerAppsPanel from "./CustomerAppsPanel";

export default function HubCustomerApps() {
  return (
    <div className="space-y-6" data-testid="hub-customer-apps">
      <div>
        <div className="text-[10.5px] font-semibold tracking-[0.22em] uppercase text-slate-600">Customer applications</div>
        <h1 className="mt-1 text-[26px] tracking-[-0.02em] font-semibold text-slate-900">Applications the customer filled in themselves</h1>
        <p className="mt-1 text-[13.5px] text-slate-500 max-w-2xl">
          Introducers send their customers a private link from their portal. Everything that comes back lands here first —
          no lender sees it until you approve it. Approving routes it exactly like a deal typed in by hand.
        </p>
      </div>
      <CustomerAppsPanel />
    </div>
  );
}
